<div class="sad">
  <div class="sad__header">
    <div class="sad__title-row">
      <h2 class="sad__title">{{ getTitle() }}</h2>
      <button type="button" class="sad__close" [disabled]="pickerCreating" (click)="cancel()" aria-label="Close">
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
          <line x1="6" y1="6" x2="18" y2="18" stroke="currentColor" stroke-width="2" stroke-linecap="round"></line>
          <line x1="18" y1="6" x2="6" y2="18" stroke="currentColor" stroke-width="2" stroke-linecap="round"></line>
        </svg>
      </button>
    </div>
    @if (relatedRecord && currentStep === 1) {
      <div class="sad__subject">
        <span class="sad__subject-avatar">{{ getRecordInitials() }}</span>
        <span class="sad__subject-name">{{ getRecordDisplayName() }}</span>
      </div>
    }
  </div>

  @if (currentStep === 1) {
    <div class="sad__body">
      <div class="sad__intro-block">
        <div class="sad__intro-title">Choose a meeting template for this invitation</div>
        <div class="sad__intro-helper">To get started, select a meeting template you'd like to use. You can also create a basic template here, but full customization is only available on the scheduling page.</div>
      </div>
      <booking-event-picker
        [selectedEvent]="selectedEvent"
        [listAllEvents]="listAllEvents"
        (eventSelected)="onEventSelected($event)"
        (creatingChange)="onPickerCreatingChange($event)">
      </booking-event-picker>
    </div>
    <div class="sad__footer">
      <button type="button" class="sad__btn sad__btn--secondary" [disabled]="pickerCreating" (click)="cancel()">Cancel</button>
      <button type="button"
        class="sad__btn sad__btn--primary"
        [disabled]="!selectedEvent?._id || pickerCreating"
        (click)="onContinueFromStep1()">
        Continue
      </button>
    </div>
  }

  @if (currentStep === 2) {
    <invite-compose-form
      [event]="selectedEvent"
      [relatedRecord]="relatedRecord"
      [showBackButton]="reachedStep2FromPicker"
      (backRequested)="onBackFromStep2()"
      (cancelled)="cancel()"
      (sent)="onSent($event)">
    </invite-compose-form>
  }
</div>